<template>
  <div class="home">
    <div class="wrapper-content">
      <div class="breadcrumb_box">
        <div class="container-fluid">
          <h2>Transaction Detail</h2>
        </div>
      </div>

      <div class="addMoney">
        <div class="container">
          <div class="addMoneyContainer">
            <div class="transactionDetailHeader">
              <div class>
                <img src="../assets/images/rupees_credit.png" />
              </div>
              <h2>
                <span>{{moreDetails.tranType}}</span>
                {{currency}}{{moreDetails.totalAmount}}
              </h2>
              <div class="statusTransaction successTranscation">Paid Successfully</div>
            </div>
            <div class="transactionDetailContainer">
              <table>
                <tbody>
                  <tr>
                    <th>Date</th>
                    <td>{{newdate(transaction.date)}}</td>
                  </tr>
                  <tr>
                    <th>Wallet Txn Id</th>
                    <td># {{$route.query.id}}</td>
                  </tr>
                  <tr>
                    <th>Total Balance</th>
                    <td>{{currency}}{{transaction.totalOrderSubscriptionPrice}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <h4>Order Details</h4>
            </div>
            <div class="transactionDetailContainer subscriptionCustom">
              <table v-if="subscriptions">
                <h5>Subsciptions</h5>
                <tbody>
                  <tr v-for="(item,index) in subscriptions" :key="index">
                    <th>{{item.name}}</th>
                    <td>Qty: {{item.quantity}}</td>
                    <td>{{currency}}{{item.pro_price}}</td>
                  </tr>
                </tbody>
              </table>
              <table v-if="oneTimeOrders">
                <h5>One Time Orders</h5>
                <tbody>
                  <tr v-for="(item,index) in oneTimeOrders" :key="index">
                    <th>{{item.name}}</th>
                    <td>Qty: {{item.quantity}}</td>
                    <td>{{currency}}{{item.pro_price}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTransactionDetail } from "./../services/api";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      transaction: "",
      currency: localStorage.getItem("CurrencySymbol"),
      subscriptions: "",
      oneTimeOrders: "",
      moreDetails: ""
    };
  },
  created() {
    this.getDetail();
    this.moreDetails = JSON.parse(localStorage.getItem("transactionInfo"))[0];
    console.log(this.moreDetails);
  },
  methods: {
    newdate(value) {
      if (value) {
        return moment(value).format("DD MMMM, YYYY hh:mm A");
      }
    },
    getDetail() {
      if (!localStorage.getItem("userName")) {
        localStorage.clear();
        this.$router.push({ name: "register" });
      } else {
        var requestData = {
          user_id: localStorage.getItem("userId"),
          vendor_id: localStorage.getItem("vendorId"),
          transaction_id: this.$route.query.id,
          token: localStorage.getItem("token")
        };
        getTransactionDetail(requestData)
          .then(result => {
            if (result.data.successCode === 1) {
              console.log("***", result);
              this.transaction = result.data.products.data;

              this.subscriptions = this.transaction.items.subItems;
              this.oneTimeOrders = this.transaction.items.oneTimeItems;
            } else if (
              result.data.successCode === 0 &&
              result.data.messageCode === 1053
            ) {
              localStorage.clear();
              this.$router.replace({ name: "register" });
            }
          })
          .catch(error => {
            return;
          });
      }
    }
  }
};
</script>
